import { useNavigate } from '@tanstack/react-router';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { DASHBOARDS } from './registry';

/**
 * Picks which dashboard is on screen. Navigates rather than swapping local
 * state, so the choice lives in the URL and a dashboard can be linked to.
 */
export function DashboardSwitcher({ current }: { current: string }) {
  const navigate = useNavigate();

  return (
    <Select
      value={current}
      // `search: (prev) => prev` carries the reporting period across the
      // switch. Omitting it lets the router replace search with `{}`, silently
      // dropping the user back to the current month on the new dashboard.
      onValueChange={(id) =>
        navigate({
          to: '/dashboard/$dashboardId',
          params: { dashboardId: id },
          search: (prev) => prev,
        })
      }
    >
      <SelectTrigger className="w-[220px]" aria-label="Dashboard">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {DASHBOARDS.map((d) => (
          <SelectItem key={d.id} value={d.id}>
            {d.title}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
